import {Row, Col, Button, Modal, Form} from 'react-bootstrap';
import {useState, useEffect, useRef, useCallback} from 'react';
import { toast } from 'react-toastify';

import { AgGridReact } from 'ag-grid-react'; 
import "ag-grid-community/styles/ag-grid.css"; 
import "ag-grid-community/styles/ag-theme-alpine.css"; 
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {useGetRepsQuery, useCreateRepMutation, useUpdateRepMutation, useDeleteRepMutation} from '../slices/repSlice';
import DeleteButtonCellRender from '../components/siteDetailComponents/cellRenders/DeleteButtonCellRender';
import EditButtonCellRender from '../components/siteDetailComponents/cellRenders/EditButtonCellRender';
import '../assets/styles/directory.css';
import useDynamicHeight from '../hooks/useDynamicHeight';

const RepScreen = () => {

    const navigate = useNavigate();
    const {userInfo} = useSelector((state) => state.auth);
    useEffect(() => {
        if(!userInfo){
            navigate('/login');
        }
    }, [userInfo, navigate])

    const newRep = {
        company: '',
        name: '',
        title: '',
        email: '',
        phoneNumber: '',
        cellNumber: ''
    }

    
    const [isLoading, setIsLoading] = useState(true)
    const {data: repss} = useGetRepsQuery(undefined, {
        skip: !userInfo
    });
    const [gridContainerRef, gridHeight] = useDynamicHeight([repss]);
    const [createRep] = useCreateRepMutation();
    const [updateRep] = useUpdateRepMutation();
    const [deleteRep] = useDeleteRepMutation();
    const [reps, setReps] = useState();
    const[rep, setRep] = useState(newRep);
    const[submitAction, setSubmitAction] = useState();
    const [show, setShow] = useState(false);
    const [showError, setShowError] = useState(false);
    const [quickFilterText, setQuickFilterText] = useState('');
    const repRef = useRef();
    repRef.current = rep;
    const repsRef = useRef();
    repsRef.current = reps;

    const gridRef = useRef();

    useEffect(() => {
        if(rep){
            setRep(rep);
        }
    }, [rep])

    useEffect(() => {
        if(repss){
            setReps(repss)
        }
    }, [repss])

    useEffect(() => {
        if(reps){

            setIsLoading(false);
        }
    }, [reps])

    const onGridReady = (params) => {
        gridRef.current = params.api;
      };
    
    const handleCloseError = () => {
        setShowError(false);
        setRep(newRep);
    }
       
    const handleClose = () => {
        setShow(false);
        setRep(newRep);
    }
    const handleShow = (e) => {
        setSubmitAction(() => createRepHandler);
        setShow(true);
    }

    const onChange = event => {
        const {name, value} = event.target;
        setRep(prevState => ({
            ...prevState,
            [name]:value
        }));
    }

    
    const createRepHandler = async () => {
        setShow(false);
        const currRep = repRef.current;
        try{
            const res = await createRep(currRep).unwrap();
            console.log(res.addedRep);
            toast.success(res.message);
            setReps([...reps, res.addedRep])
            setRep(newRep);
        }catch (error){
            toast.error(error?.data?.message || error.error);
        }
    }

    const updateRepHandler = async () => {
        const currRep = repRef.current;
        const res = await updateRep(currRep).unwrap();
        const updatedReps = repsRef.current.map(arrRep =>
            arrRep._id === res.updatedRep._id ? res.updatedRep : arrRep
        );
        setReps(updatedReps);
        setShow(false);
        toast.success(res.message);
    }

    const removeRepHandler = async () => {
        const currRep = repRef.current;
        const res = await deleteRep(currRep._id).unwrap();
        const index = reps.findIndex(rep => rep._id === currRep._id);
        if (index !== -1) {
          const newArray = [...reps.slice(0, index), ...reps.slice(index + 1)];
          setReps(newArray);
        }
        setShowError(false);
        setRep(newRep);
        toast.success(res.message);
    }


    const [colDefs] = useState([
        {field: "company"},
        {field: "name"},
        {field: "title"},
        {field: "email"},
        {field: "phoneNumber"},
        {field: "cellNumber"},
        {headerName: 'Edit', field: 'actions', width:80, cellRenderer: EditButtonCellRender,
            cellRendererParams: {
                onEdit: (repId) => {
                    console.log("HIT EDIT");
                    console.log(repId);
                    console.log(repsRef.current);
                    const foundRep = repsRef.current.find(rep => rep._id === repId._id);
                    if (foundRep) {
                        console.log("IN LOOP");
                        setRep(foundRep);
                        setSubmitAction(() => updateRepHandler)
                        setShow(true);
                    }
                }
            }
        },
        {headerName: 'Delete', field: 'delete', cellRenderer: DeleteButtonCellRender,
            cellRendererParams: {
                onDelete: (repId) => {
                    const foundRep = repsRef.current.find(rep => rep._id === repId);
                    if (foundRep) {
                        setRep(foundRep);
                        setShowError(true);
                    }
                }
            }
        }
    ]);

    const onExportClick = useCallback(() => {
        const fileName = 'reps_' + Date.now() + ".csv";
        gridRef.current.exportDataAsCsv({fileName: fileName});
      }, []);


      const onQuickFilterChange = (event) => {
        setQuickFilterText(event.target.value);
        if (gridRef.current && gridRef.current.api) {
          gridRef.current.api.setQuickFilter(event.target.value);
        }
      };


   
    if (!userInfo) {
        return null;
    }

    return  isLoading ? (
        <div className="text-center py-5">
            <h2 className="text-white">Loading Contacts...</h2>
        </div>
    ) : (
        <>
            <div className='modern-directory-container'>

                <Modal show={showError} onHide={handleCloseError} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Delete Rep</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Are you sure you want to delete this rep?</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseError}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={removeRepHandler}>
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={show} onHide={handleClose} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>{rep._id ? 'Edit Rep Details' : 'Add New Rep'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Col>
                                    <Form.Group className="mb-3" controlId="formName">
                                        <Form.Label>Name</Form.Label>
                                        <Form.Control 
                                            name="name"
                                            value={rep.name}
                                            onChange={onChange}
                                            type="text" 
                                            placeholder="Enter representative's name" 
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formCompany">
                                        <Form.Label>Company</Form.Label>
                                        <Form.Control 
                                            name="company"
                                            value={rep.company}
                                            onChange={onChange}
                                            type="text" 
                                            placeholder="Enter company name" 
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formTitle">
                                        <Form.Label>Title</Form.Label>
                                        <Form.Control 
                                            name="title"
                                            value={rep.title}
                                            onChange={onChange}
                                            type="text" 
                                            placeholder="e.g. Sales Account Manager" 
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formEmail">
                                        <Form.Label>Email Address</Form.Label>
                                        <Form.Control 
                                            name="email"
                                            value={rep.email}
                                            onChange={onChange}
                                            type="text" 
                                            placeholder="email@example.com" 
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formPhone">
                                        <Form.Label>Office Phone</Form.Label>
                                        <Form.Control 
                                            name="phoneNumber"
                                            value={rep.phoneNumber}
                                            onChange={onChange}
                                            type="text" 
                                            placeholder="Office number" 
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formCell">
                                        <Form.Label>Cell Phone</Form.Label>
                                        <Form.Control 
                                            name="cellNumber"
                                            value={rep.cellNumber}
                                            onChange={onChange}
                                            type="text" 
                                            placeholder="Mobile number" 
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        <Button id='modalSubmitButton' variant="success" onClick={submitAction}>
                            Save Changes
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Header Block */}
                <div className="directory-header-block flex-column flex-md-row align-items-start align-items-md-end gap-3">
                    <div>
                        <div className="directory-tag">Contacts Directory</div>
                        <h1 className="directory-title">Sales & Support Representatives</h1>
                        <p className="directory-subtitle">
                            Manage manufacturer reps, vendor technicians, and ISP account managers.
                        </p>
                    </div>
                </div>

                {/* Controls Row */}
                <div className="directory-controls-row mt-4 flex-column flex-sm-row gap-3">
                    <div className="directory-search-col">
                        <Form.Control
                            type="text"
                            placeholder="Filter representatives..."
                            value={quickFilterText}
                            onChange={onQuickFilterChange}
                            className="filter-control"
                        />
                    </div>
                    <div className="directory-actions-col">
                        <Button className="btn-primary-glass" onClick={handleShow}>
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="me-1">
                                <line x1="12" y1="5" x2="12" y2="19"></line>
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg>
                            Add Rep
                        </Button>
                        <Button className="btn-outline-glass" onClick={onExportClick}>
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="me-1">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                <polyline points="7 10 12 15 17 10"></polyline>
                                <line x1="12" y1="15" x2="12" y2="3"></line>
                            </svg>
                            Export to CSV
                        </Button>
                    </div>
                </div>

                {/* Representatives Grid */}
                <Row className="mt-3">
                    <Col>
                        <div ref={gridContainerRef} className="ag-theme-alpine" style={{ height: gridHeight }} >
                            <AgGridReact
                                ref={gridRef}
                                rowData={reps}
                                columnDefs={colDefs}
                                suppressExcelExport={true}
                                frameworkComponents={{
                                    EditButtonCellRenderer: EditButtonCellRender,
                                    DeleteButtonCellRender: DeleteButtonCellRender
                                }}
                                onGridReady={onGridReady}
                                quickFilterText={quickFilterText}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default RepScreen;